module.exports = __webpack_public_path__ + "img/login_background.34852927.jpg";